import { render, staticRenderFns } from "./NewsCensus.vue?vue&type=template&id=47b6f3d0&scoped=true"
import script from "./NewsCensus.vue?vue&type=script&lang=js"
export * from "./NewsCensus.vue?vue&type=script&lang=js"
import style0 from "./NewsCensus.vue?vue&type=style&index=0&id=47b6f3d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b6f3d0",
  null
  
)

export default component.exports